<template>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
         <v-btn small depressed v-on="on" color="primary"><v-icon class='pr-2'>mail</v-icon>Compose Message</v-btn>
      </template>

      <v-card >
        <v-card-title v-if='userData'
          class="headline grey lighten-2"
          primary-title
        >
          Message {{userData.info.name}}
        </v-card-title>
         <v-card-title v-else
          class="headline grey lighten-2"
          primary-title
        >
          Compose a new message
        </v-card-title>
        <v-card-text class='pt-5'>
          <v-text-field v-if='!userData'
           v-model='message_to'
            label="Recipient Email Address"
            placeholder="Please Enter the email address of the recipient"
            outlined
          ></v-text-field>
           <v-text-field
           v-model='title'
            label="Title"
            placeholder="Enter title of the message here"
            outlined
          ></v-text-field>
          <v-textarea
          outlined
          v-model='messageBody'
          name="input-7-4"
          label="Message Body"
          placeholder="Enter message here"
        ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="sendMessage()"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import  shortid  from 'shortid';
import { mapFields } from 'vuex-map-fields';
import { postReq} from '../../helper/firestore'

  export default {
    props : {
      userData :Object,
    },
    mounted(){
    },
    data () {
      return {
          title : null,
          messageBody : null,
          message_to : null,
          dialog: false,
      }
    },
    computed : {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    },
    methods : {
      prepareMessage(){
        if(this.userData){
          this.message = {
          messageType : "system",
          message_from: {
            uid : this.user.uid,
            email : this.user.email,
          },
          messageID : shortid.generate(),
          createdAt :  this.$moment().format("MM/DD/YYYY HH:mm:ss"),
          messageBody : this.messageBody,
          read : false,
          title : this.title,
          message_to : {
            uid :  this.userData.uid,
            email : this.$route.params.value
          }
        }
        }
        else{
          this.message = {
          messageType : "non-system",
          message_from: {
            uid : this.user.uid,
            email : this.user.email
          },
          messageID : shortid.generate(),
          createdAt :  this.$moment().format("MM/DD/YYYY HH:mm:ss"),
          messageBody : this.messageBody,
          read : false,
          title : this.title,
          message_to : {
            uid : null,
            email : this.message_to
            }
          }
        }
      },
      sendMessage(){
        this.prepareMessage()
       postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/messages/sendMessages',{message :this.message},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "message sent"
        })
        this.dialog = false
      },
    }
  }
</script>

<style>

</style>
